import styled from "styled-components";
import PageWrapper from "Components/Pages/Wrapper";

export const SelectTitle = styled.h2`
  color: var(--color-purple);
  font-size: 18px;
  font-weight: 400;
  line-height: 25px;
`;

export const Container = styled.div`
  max-height: 100vh;
  overflow: auto;
  &.gray-background {
    background: #f5f5f5;
  }

  .tabs {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    margin-bottom: 15px;

    button {
      border-radius: 5px;
      font-weight: 600;

      &:hover {
        background: var(--color-purple);
        color: white;
      }
    }
  }
  .documents {
    margin-top: 30px;
    position: relative;

    .documents-preview-style {
      .tabs {
        flex-direction: column;
      }
    }

    .documents-preview {
      overflow: hidden;

      .document-item-style {
        display: flex;
        justify-content: center;
      }
    }
  }

  &.card-search-information {
    padding-right: 20px;
    padding-left: 20px;
    grid-column: 1/2;
    grid-row: 2/3;
    margin: 0;
  }

  .overlay-progress-ia {
    position: fixed;
    inset: 0;
    overflow: hidden;
    background: rgba(103, 103, 153, 0.7);
    z-index: 999;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .title-search-products-budget {
    margin-bottom: 0;
  }
  .progress {
    display: flex;
    align-items: center;
    position: relative;
    background: white;
    padding: 40px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);

    .bot {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .btn-ia {
    border-radius: 8px;
    padding: 2px 10px;
  }
`;

export const CartStyles = styled.div`
  grid-area: 1 / 2 / 3 / 3;
  border-top: none;
  border-left: 1px solid rgb(196, 196, 196);
  position: unset;
  width: auto;
  max-height: 100vh;
  overflow: auto;

  .tracking-history {
    max-height: unset;
  }
  .tab-show {
    padding: 20px;
  }

  .tracking-button {
    font-size: 14px;
    padding: 8px 16px;
    height: auto;
  }

  .tracking-history {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;

    h6 {
      margin: 0 0 15px 0;
      color: var(--color-purple);
      font-size: 16px;
    }
  }

  .track-item {
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 10px;
  }

  .track-original {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f3f4;
  }

  .match-info {
    color: #666;
    font-size: 14px;
    margin-left: 8px;
  }

  .track-corrections {
    ul {
      margin: 5px 0 0 0;
      padding-left: 20px;
    }

    li {
      margin: 2px 0;
      font-size: 14px;
    }
  }

  .removed {
    color: var(--color-danger);
    font-style: italic;
  }
`;

export const PageContainer = styled(PageWrapper)`
  box-sizing: border-box;
  max-height: 100vh;

  &.app-content .content-holder .page-heading {
    z-index: 0;
  }

  @media (min-width: 1260px) {
    &.app-content .content-holder {
      padding-top: 0;
      padding-bottom: 0px;
      height: 100%;
      overflow: hidden;
    }
  }
`;

export const PageContent = styled.div`
  flex: 1;
  height: 100%;
  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 391px;

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 570px;
  }
`;

export const PageHeading = styled.div`
  grid-row: 1/2;
  grid-column: 1/2;
  width: auto;
`;

export const PageBody = styled.div`
  padding: 0;
  margin-bottom: 20px;
  grid-row: 1/3;
  grid-column: 1/3;

  display: grid;
  grid-template-rows: 132px 1fr;
  grid-template-columns: 1fr 391px;

  .card-search-information {
    padding-right: 20px;
    padding-left: 20px;

    grid-column: 1/2;
    grid-row: 2/3;
    margin: 0;
  }
  .cart-information-resume {
    grid-column: 2/3;
    grid-row: 1/3;

    border-top: none;
    padding: 20px 20px;
    border-left: 1px solid #c4c4c4;
    position: unset;
    width: auto;
    padding-right: 0;
    // width: 100%;
    // max-width: 100vw;
    // white-space: normal;
    // word-wrap: break-word;;
  }

  @media (min-width: 1600px) {
    grid-template-columns: 1fr 550px;
  }
`;
